'use client';

import { ErrorBoundary } from '@appsignal/react';
import { PropsWithChildren, useEffect, useState } from 'react';

import { MarketingScripts } from '@/components/MarketingScripts';
import { LayoutContextProvider } from '@/context/layout-context';
import { ZmyleCookieProvider } from '@/hooks/useZmyleCookieStore';
import { MobileNavigationProvider } from '@/layout/Navigation/Mobile/mobile-navigation-context';
import { AppSignalClient } from '@/services/appSignal';
import { ClientConfig, IClientConfig } from '@/services/clientConfig';

export type ZmyleCookieConfig = {
  zmyleCookie: ZmyleCookie;
  scriptVersion: string;
  zmyleApi: string;
};

export type ProvidersProps = PropsWithChildren<{
  zmyleCookieConfig: ZmyleCookieConfig;
  layoutContent: LayoutContent;
  clientConfig: IClientConfig;
}>;

export function Providers({
  children,
  zmyleCookieConfig,
  layoutContent,
  clientConfig,
}: ProvidersProps) {
  const [isConfigReady, setIsConfigReady] = useState(false);

  useEffect(() => {
    ClientConfig.set(clientConfig);

    AppSignalClient.init();

    setIsConfigReady(true);
  }, [clientConfig]);

  if (!isConfigReady) return null;

  const appSignal = AppSignalClient.getInstance().getClient();

  return (
    <ErrorBoundary instance={appSignal}>
      <ZmyleCookieProvider zmyleCookie={zmyleCookieConfig.zmyleCookie}>
        <MarketingScripts />

        <LayoutContextProvider content={layoutContent}>
          <MobileNavigationProvider>{children}</MobileNavigationProvider>
        </LayoutContextProvider>
      </ZmyleCookieProvider>
    </ErrorBoundary>
  );
}
